<template>
  <div class="Restrooms">
    <v-container fluid grid-list-md fill-height>
      <v-layout row wrap justify-center align-center>
        <v-flex xs12>
          <v-card class="pa-2">
            <v-card-text>
              <v-layout wrap justify-space-between>
                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuIni"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicial"
                      v-model="dateIni"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser anterior a la fecha final"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateIni"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuEnd"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Final"
                      v-model="dateEnd"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser posterior a la fecha inicial"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateEnd"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md3>
                  <v-autocomplete
                    :items="restRooms"
                    label="Filtrar por baño"
                    v-model="restroom"
                    :disabled="loading"
                    color="secondary"
                    hide-no-data
                    hint="Vacio para no filtrar por este campo"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn color="warning"
                :disabled="loading"
                @click="clear()"
              >
                Limpiar
              </v-btn>

              <v-btn
                color="info"
                :disabled="loading || vDate"
                @click="loadReport()"
              >
                <v-icon left>cloud_download</v-icon> Cargar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card class="mb-2">
            <v-card-title class="title">
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="loading || dataVals.length < 1">
                  <download-csv
                    :data="dataVals"
                    :name="'Reporte de Baños.csv'"
                    :labels="labels"
                    :fields="fields"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                class="text-xs-center"
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headers"
                :items="dataVals"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                rows-per-page-text="Filas por página:"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.ubicacion }}</td>
                  <td>{{ props.item.fecha }}</td>

                  <td class="justify-center">
                    <v-icon
                      :color="props.item.aseo ? 'success' : 'error'"
                      class="mr-2"
                      v-text="props.item.aseo ? 'check' : 'clear'"
                    ></v-icon>
                  </td>

                  <td class="justify-center">
                    <v-icon
                      :color="props.item.toallas ? 'success' : 'error'"
                      class="mr-2"
                      v-text="props.item.toallas ? 'check' : 'clear'"
                    ></v-icon>
                  </td>

                  <td class="justify-center">
                    <v-icon
                      :color="props.item.papel ? 'success' : 'error'"
                      class="mr-2"
                      v-text="props.item.papel ? 'check' : 'clear'"
                    ></v-icon>
                  </td>

                  <td class="justify-center">
                    <v-icon
                      :color="props.item.jabon ? 'success' : 'error'"
                      class="mr-2"
                      v-text="props.item.jabon ? 'check' : 'clear'"
                    ></v-icon>
                  </td>
                  <td>{{ props.item.observaciones }}</td>

                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      class="mr-2"
                      @click="getItem(props.item)"
                    >
                      camera_alt
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog
              v-model="dialog"
              max-width="600px"
            >
              <v-card v-if="itemSelected">
                <v-card-title>
                  <span class="title">
                    {{ itemSelected.ubicacion }} / {{ itemSelected.fecha }} <br>
                  </span>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cerrar</v-btn>
                </v-card-title>

                <v-divider />

                <v-tabs
                  v-model="tabs"
                  centered
                  color="transparent"
                  slider-color="iK"
                  :key="tabsKey"
                >
                  <v-tab
                    v-for="i in 3"
                    :key="i"
                    :href="`#tab-${i}`"
                  >
                    Foto {{ i }}
                  </v-tab>

                  <v-tab
                    :href="`#tab-firma`"
                  >
                    Firma
                  </v-tab>

                  <v-tabs-items>
                    <v-tab-item
                      v-for="i in 3"
                      :key="i"
                      :value="'tab-' + i"
                    >
                      <v-img
                        contain
                        :src="itemSelected['foto_' + i]"
                      >
                      </v-img>
                    </v-tab-item>

                    <v-tab-item
                      :value="`tab-firma`"
                    >
                      <v-img
                        contain
                        :src="itemSelected.firma"
                      >
                      </v-img>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'Restrooms',

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
  },

  components: {
    'download-csv': JsonCSV
  },

  data: function () {
    return {
      backConf: {
        path: '/aseo/reporte/',
        page: 1
      },

      search: '',
      dialog: false,
      loading: false,
      progressSize: 70,
      progressWidth: 7,
      completed: 0,

      tabs: null,
      tabsKey: 0,

      dateIni: null,
      dateEnd: null,
      restroom: null,
      restRooms: [
        { text: 'Baño capacitaciones', value: '1' },
        { text: 'Baño agora', value: '2' },
        { text: 'Baño central ', value: '3' },
        { text: 'Ducha', value: '4' },
        { text: 'Baño Denis', value: '5' },
        { text: 'Baño lockers', value: '6' },
        { text: 'Baño escaleras', value: '7' }
      ],

      itemSelected: null,

      tableKey: 0,

      headers: [
        {
          text: ' Baño',
          align: 'left',
          value: 'ubicacion'
        },
        { text: 'Día / Hora', value: 'fecha' },
        { text: 'Aseo', value: 'aseo' },
        { text: 'Cargue de toalla de papel', value: 'toallas' },
        { text: 'Cargue de papel higenico', value: 'papel' },
        { text: 'Cargue de jabon', value: 'jabon' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Ver', sortable: false }
      ],

      labels: {
        ubicacion: 'Baño',
        fecha: 'Día / Hora',
        aseo: 'Aseo',
        toallas: 'Cargue de toalla de papel',
        papel: 'Cargue de papel higenico',
        jabon: 'Cargue de jabon',
        observaciones: 'Observaciones',
        foto_1: 'foto_1',
        foto_2: 'foto_2',
        foto_3: 'foto_3'
      },
      fields: ['ubicacion', 'fecha', 'aseo', 'toallas', 'papel', 'jabon', 'observaciones', 'foto_1', 'foto_2', 'foto_3'],

      dataVals: []
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {boolean} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    /**
     * Carga la tabla de los reportes
     */
    loadReport () {
      this.loading = true
      let request = {
        method: 'get',
        params: {
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          banio: this.restroom
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          console.error(err)
        })
    },

    getItem (item) {
      this.dialog = true
      this.itemSelected = item
      this.tabsKey += 1
    },

    close () {
      this.dialog = false
      this.tabs = null
      this.tabsKey += 1
      this.itemSelected = null
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.restroom = null
    },

    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      if (typeof val === 'string' && val[val.length - 1] !== '%') {
        algn = 'left'
      }
      return algn
    }
  }
}
</script>
